import { Route, Routes } from 'react-router-dom'

import NavigateToError from '@/features/error/pages/NavigateToError'
import { PortfolioHierarchyRouteInformation } from '@/features/portfolioHierarchy/constants'
import ActivationGroupsIndex from '@/features/portfolioHierarchy/pages/ActivationGroupsIndex'
import PortfoliosIndex from '@/features/portfolioHierarchy/pages/PortfoliosIndex'
import RegulationObjectDetails from '@/features/portfolioHierarchy/pages/RegulationObjectDetails'
import RegulationObjectsIndex from '@/features/portfolioHierarchy/pages/RegulationObjectsIndex'
import PortfolioHierarchyLayout from '@/features/portfolioHierarchy/PortfolioHierarchyLayout'

export function getPortfolioHierarchyRoutes() {
  return (
    <>
      <Route element={<PortfolioHierarchyLayout />} path="/">
        <Route index element={<PortfoliosIndex />} path={PortfolioHierarchyRouteInformation.INDEX.routePath} />
        <Route element={<PortfoliosIndex />} path={PortfolioHierarchyRouteInformation.PORTFOLIOS.routePath} />
        <Route
          element={<RegulationObjectsIndex />}
          path={PortfolioHierarchyRouteInformation.REGULATION_OBJECTS.routePath}
        />
        <Route
          element={<ActivationGroupsIndex />}
          path={PortfolioHierarchyRouteInformation.ACTIVATION_GROUPS.routePath}
        />
      </Route>

      <Route
        element={<RegulationObjectDetails />}
        path={PortfolioHierarchyRouteInformation.REGULATION_OBJECT_DETAILS.routePath}
      />

      <Route element={<NavigateToError statusCode={404} />} path="*" />
    </>
  )
}

export default function PortfolioHierarchyRoutes() {
  return <Routes>{getPortfolioHierarchyRoutes()}</Routes>
}
